module.exports = __webpack_public_path__ + "img/bg_coating.6bd94a99.png";